import store from "@/state/store";
import {PascalCase} from "@/helpers/mirai/custom";
// Primeiro criamos o contexto dos componentes. Ele irá procurar por todos os arquivos .vue dentro
// do seu diretório "views" e seus subdiretórios.
const viewsContext = require.context('../views/mirai', true);

// Agora criamos as rotas
const routes = viewsContext.keys().map((file) => {
    // Obtém o path removendo './' e '.vue'
    const last  = file.substring(file.length -1);
    file = last === '/' ? file.substring(0, file.length-1) : file;
    const path = file.replace(/(\.\/|\.vue$)/g, '');
    file = file.substring(2)
    return {
        path: `/mirai/${path.replace('.vue','').replace('/index','')}`,
        parent: path.split('/').length >= 2 ? path.split('/')[0] : null,
        main:path.split('/').length === 1,
        render:path.split('/').length !== 1,
        name: path.split('/').join('-'),
        component: () => import(
            /* webpackInclude: /\.vue$/ */
            `../views/mirai/${file}`
            ), // Usar string template diretamente
        meta: {
            title: PascalCase(path.split('/').join('-')),
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                    next();
                } else {
                    next();
                }
            },
        },
    };
});
let uniquePaths = {};
let FullRoutes = routes.filter(route => {
    if(uniquePaths[route.path]) {
        // Se o path já existe, ignora este registro
        return false;
    }
    // Caso contrário, registra no objeto e inclui no array final
    uniquePaths[route.path] = true;
    return true;
});
export default FullRoutes;